export default __webpack_public_path__ + "static/media/weapon3.aacee653.png";